import { tenantHttp, type HttpClient } from './core/http-client';
import type { NewWidget, Widget, WidgetCatalog, WidgetUpdate } from './models';

export class WidgetsService {
  constructor(private readonly http: HttpClient) {}

  catalog = () => this.http.get<WidgetCatalog>('/business/widgets/catalog');

  list = () => this.http.get<Widget[]>('/business/widgets');

  get = (id: string) => this.http.get<Widget>(`/business/widgets/${id}`);

  create = (b: NewWidget) => this.http.post<Widget>('/business/widgets', b);

  update = (id: string, b: WidgetUpdate) => this.http.patch<Widget>(`/business/widgets/${id}`, b);

  archive = (id: string) => this.http.delete(`/business/widgets/${id}`);
}

export const widgetsService = new WidgetsService(tenantHttp);
